module.exports = __webpack_public_path__ + "static/media/home-selected.3b15c396.svg";